import { StateKey } from 'common/utils/flipState'
import { fetchPagedReviews } from 'common/services/review'
import { ReviewPagingParams, ReviewSearchSortType } from 'common/types/entities/api/review'
import { BEST_REVIEW_LIST_PAGE_SIZE, BEST_REVIEW_LIST_PC_CHUNK_SIZE } from 'common/constants/review'
import { BestReviewState } from 'common/types/entities/review'

const FETCH = 'review/productBestReview/FETCH'

const initialState: BestReviewState = {
  contents: [],
  contentChunks: [],
}

export const fetchProductBestReviews = (
  curState: StateKey,
  originProductNo: string,
  naverPaySellerNo: string,
  headers?: any,
) => async dispatch => {
  const params: ReviewPagingParams = {
    originProductNo,
    page: 1,
    pageSize: BEST_REVIEW_LIST_PAGE_SIZE,
    merchantNo: naverPaySellerNo,
    bestReviewYn: true,
    sortType: ReviewSearchSortType.REVIEW_RANKING,
  }
  const pagedReview = await fetchPagedReviews(params, headers)
  if (pagedReview && pagedReview.contents && pagedReview.contents.length > 0) {
    const { contents } = pagedReview
    const contentChunks = []
    for (let i = 0; i < contents.length; i = i + BEST_REVIEW_LIST_PC_CHUNK_SIZE) {
      contentChunks.push(contents.slice(i, i + BEST_REVIEW_LIST_PC_CHUNK_SIZE))
    }

    return dispatch({
      curState,
      contents,
      contentChunks,
      type: FETCH,
    })
  }
  return dispatch({
    curState,
    type: FETCH,
    ...initialState,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        contents: action.contents,
        contentChunks: action.contentChunks,
      }
    default:
      return state
  }
}
export default reducer
